import React, { useEffect } from "react";


const RiskManagementPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `1.1 The Board of Directors (“Board”) of ${import.meta.env.VITE_COMPANY_NAME} (“Company”) has adopted the following policy, encompassing practices relating to identification, assessment, monitoring, and mitigation of various business risks.

1.2 The Risk Management Policy (“Policy”) aims to minimize unfavorable impacts on business objectives and enhance stakeholder value. It is also designed to sustain and strengthen the Company’s long-term competitive advantage.`,
    },
    {
      title: "2. Purpose",
      content: `2.1 This Policy has been framed in accordance with the Risk Management Framework issued by the Reserve Bank of India (RBI) vide Master Direction DNBR. PD. 008/03.10.119/2016-17 dated September 1, 2016, and subsequent amendments.

2.2 The Policy aims to address potential losses to the Company’s human and financial assets while maintaining flexibility in pursuing growth-oriented activities that align with the Company's goals.`,
    },
    {
      title: "3. Principles",
      list: [
        "Risk management must create and protect value.",
        "It must be integrated into organizational processes.",
        "It supports informed decision-making.",
        "It focuses on uncertainties surrounding objectives.",
        "It must be tailored to the business context.",
        "It must be dynamic, iterative, and responsive to change.",
      ],
    },
    {
      title: "4. Definitions",
      list: [
        "Board: Board of Directors of the Company.",
        `Company: ${import.meta.env.VITE_COMPANY_NAME}.`,
        "Directors: Members of the Board.",
        "Policy: Risk Management Policy.",
        "RBI: Reserve Bank of India.",
      ],
    },
    {
      title: "5. Policy Objectives",
      list: [
        "Continuously identify organizational risks affecting business operations.",
        "Safeguard shareholder rights and value through a comprehensive risk management framework.",
        "Enhance and maintain tools and processes to support strategic and operational decision-making.",
      ],
    },
    {
      title: "6. Risk Identification, Measurement, and Assessment",
      content: `6.1 Management, under the Board’s oversight, is responsible for implementing the Risk Management Program and risk identification processes.

6.2 Risks are measured through qualitative and quantitative methods based on likelihood and impact.

6.3 Risks are categorized into inherent and residual types depending on their potential effect.

6.4 Key Risk Categories Identified:`,
      list: [
        "Strategic Risk",
        "Operational Risk",
        "Market Risk",
        "Financial Risk",
        "Credit & Concentration Risk",
        "Regulatory & Compliance Risk",
        "Human Resource Risk",
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-[#EFFFFD] font-['Inter',sans-serif] pt-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E50] mb-4">
            Risk Management Policy
          </h1>
          <p className="text-lg text-[#2C3E50]/80 max-w-3xl mx-auto">
            At{" "}
            <span className="font-semibold text-[#21A6B5]">
              {import.meta.env.VITE_COMPANY_NAME}
            </span>
            , our risk management framework ensures early identification,
            assessment, and mitigation of business risks to protect company
            value and foster sustainable growth.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 space-y-8">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-3">
              <h2 className="text-xl md:text-2xl font-bold text-[#2C3E50] border-b-2 border-[#21A6B5]/30 pb-2">
                {section.title}
              </h2>
              {section.content && (
                <p className="text-[#2C3E50]/80 text-base whitespace-pre-line leading-relaxed">
                  {section.content}
                </p>
              )}
              {section.list && (
                <ul className="list-disc list-outside ml-6 space-y-2 text-[#2C3E50]/80 text-base">
                  {section.list.map((li, i) => (
                    <li key={i} className="pl-1">{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
};

export default RiskManagementPolicy;
